// @flow

import active from './active'
import alerts from './alerts'

export default alerts.merge(active)
